document.addEventListener('DOMContentLoaded', function () {
    const subscriptionWidget = document.querySelector("[js-subscription-widget]");
    if(subscriptionWidget) {
      const subscriptionAllocations = subscriptionWidget.querySelectorAll('[js-subscription-allocation]');
      const tabOptions = subscriptionWidget.querySelectorAll('[js-subscription-option] input');
      const plans = subscriptionWidget.querySelectorAll('[js-subscription-plan]');

      function updatePlans({ target }) {
        let plan = target.getAttribute("is");

        tabOptions.forEach((option, index) => {
            if (option.checked) {
                plan = option.getAttribute("is");
              plans.forEach((plan, i) => {
                plan.style.display = i === index ? 'flex' : 'none';
              });
            }
        });

        const cr_allocation = subscriptionWidget.querySelector(`[js-subscription-allocation]:checked`);

   

        if(plan === "subscription") {
          cr_allocation.removeAttribute("disabled");
        }else {
          cr_allocation.setAttribute("disabled","disabled");
        }
        updateSelectedPrice()
      }

      tabOptions.forEach(option => {
        option.addEventListener('change', updatePlans);
      });

      const defaultOption = subscriptionWidget.querySelector('[js-subscription-option] [name="purchase_type"]');
      const defaultSubscrptionInput = subscriptionWidget.querySelector('[js-subscription-allocation]');
      if (defaultOption && defaultSubscrptionInput) {
        setTimeout(() => {
            defaultOption.click();
            defaultSubscrptionInput.click();
        }, 1000)
      }
      
  
      const productSubscriptionVariants = subscriptionWidget.querySelectorAll('[js-product-option-items]');
      const productVariants = document.querySelectorAll('[js-product-variant]');
      productSubscriptionVariants.forEach((subscriptionEl) => {
        subscriptionEl.addEventListener('change', function() {
          const index = this.getAttribute("data-index");
          const variantEl = productVariants[index];
          if (variantEl) {
            variantEl.click();
          }

          const cr_allocation = subscriptionWidget.querySelector(`[js-subscription-allocation][data-index="${index}"]`);
          if(cr_allocation) {
            cr_allocation.checked = true;

            subscriptionAllocations.forEach(el => el.removeAttribute("disabled"));
            cr_allocation.setAttribute("disabled","disabled");
          }

          updateSelectedPrice();
        });
      });

      subscriptionAllocations.forEach((el) => {
        el.addEventListener('change', function() {
          const index = this.getAttribute("data-index");
          const cr_option = subscriptionWidget.querySelector(`[js-product-option-items][data-index="${index}"]`);
          if(cr_option) {
            cr_option.checked = true
          }

          const variantEl = productVariants[index];
          if (variantEl) {
            variantEl.click();
          }
          updateSelectedPrice();
        });
      });

      function updateSelectedPrice() {
      const subscriptionWidget = document.querySelector("[js-subscription-widget]");
      const activeTabOption = subscriptionWidget.querySelector('[js-subscription-option] input:checked');
      if (!activeTabOption) return;

      const purchaseType = activeTabOption.getAttribute("is");
      let checkedInput;

      if (purchaseType === "subscription") {
        checkedInput = subscriptionWidget.querySelector('input[js-subscription-allocation]:checked');
      } else {
        checkedInput = subscriptionWidget.querySelector('input[js-product-option-items]:checked');
      }

      if (!checkedInput) return;

      const label = checkedInput.closest('label');
      if (!label) return;

      const discountedPrice = parseInt(label.dataset.discoundedPrice, 10) / 100;
      const regularPrice = parseInt(label.dataset.regularPrice, 10) / 100;

      const addToCartBtn = document.querySelector('[js-form-buy-now-button]');
      if (addToCartBtn) {
        const addToCartButtonText = addToCartBtn.querySelector('.btn--text');
        
        const showRegularPrice = regularPrice > discountedPrice;
        
        const priceHtml = `
          <span class="hb-btn__price--wrapper">
            <span class="hb-btn__discounded--price">$${(discountedPrice % 1 === 0 ? discountedPrice.toFixed(0) : discountedPrice.toFixed(2))}</span>
            ${showRegularPrice ? `<span class="hb-btn__regualar--price">$${regularPrice % 1 === 0 ? regularPrice.toFixed(0) : regularPrice.toFixed(2)}</span>` : ''}
          </span>
        `;

        if (addToCartBtn.classList.contains('Preorder')) {
          addToCartButtonText.innerHTML = `PRE-ORDER – ${priceHtml}`;
        } else {
          addToCartButtonText.innerHTML = `ADD TO CART – ${priceHtml}`;
        }
      }
      
    }
      updateSelectedPrice();
      document.addEventListener('update-selected-price:init', updateSelectedPrice)
    }
  });